import {
  Component, ChangeDetectorRef, ElementRef, HostListener, Inject, NgZone,
  OnInit, OnDestroy, QueryList, ViewChild, ViewChildren, HostBinding, ChangeDetectionStrategy
} from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription ,  Observable ,  BehaviorSubject ,  Subject, merge } from 'rxjs';



import * as moment from 'moment';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';

import { publishedToast, unpublishedToast } from 'shared/toaster/toasts';
import { itemWasUpdatedToast } from 'shared/toaster/toasts';
import { segments } from './segments-list';
import { SegmentsParams } from 'shared/segments-navigation/segments-navigation/segments-navigation-params.interface';
import segmentsAsyncs from './segments-asyncs';
import { rightPanelNavs } from './right-panel-navs';
import { SideNavButtonModel } from 'shared/status-sidenav/status-sidenav/side-nav.model';
import { Config } from 'shared/config/env.config';
import { indexPagesData } from 'utils/index-pages-data';
import { getFieldByMap, getItemProperty } from 'utils/utils';
import { headerHeight, navPanelHeight } from '../variables';
import { setItemDetailValidation } from 'shared/item-detail/item-detail-validation';
import { getAssetThumbnail } from 'shared/digital-assets/digital-asset-helpers';
import { productPreviewOptions } from './preview-options';
import * as productHelpers from 'shared/product/product-helpers';
import * as searchPageHelpers from 'shared/search-page/search-page.helpers';
import { ReturnRouteModel } from 'shared/return-route/return-route.model';
import { setUnreadCommentsCount } from 'shared/comments/comments-helpers';

import { SegmentsNavigationComponent } from 'shared/segments-navigation/segments-navigation/segments-navigation.component';
import { BaseRoutingPageComponent } from 'shared/base/_base-routing-page.component';
import { ProductPanelComponent } from '../product-panel/product-panel.component';
import { StickyComponent } from 'shared/sticky/sticky.component';
import { DynamicNavsComponent } from 'shared/nav/dynamic-navs/dynamic-navs.component';
import { FitmentsComponent } from './components/fitments/fitments.component';
import { LoaderComponent } from 'shared/loader/loader.component';

import { ProductDetailsService } from './product-details.service';
import { ScrollToService } from 'shared/base/scroll-to.service';
import { SegmentValidationService } from 'shared/validation/segment-validation/segment-validation.service';
import { StickyService } from 'shared/sticky/sticky.service';
import { ProductPanelService } from '../product-panel/product-panel.service';
import { BrandService } from 'shared/brand/brand.service';
import { ItemDetailService } from 'shared/item-detail/item-detail.service';
import { SessionService } from 'shared/session/session.service';
import { PriceSheetService } from 'shared/price-sheet/price-sheet.service';
import { ProductGroupsService } from 'shared/product-groups/product-groups.service';
import { MarketingCopyDetailsService } from 'shared/marketing-copy/marketing-copy-details.service';
import { HintsService } from 'shared/hints/hints.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { ReturnRouteService } from 'shared/return-route/return-route.service';
import { CommentsService } from 'shared/comments/comments.service';
import { PreferencesService } from 'shared/preferences/preferences.service';

import { ConvertUTCToTZPipe } from 'shared/pipes/convert-utc-to-tz.pipe';
import { statusLookup } from 'shared/my-products/my-products-statuses';
import {first, flatMap, takeWhile} from 'rxjs/operators';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';
import {forkJoin} from 'rxjs/internal/observable/forkJoin';


@Component({
  moduleId: module.id,
  selector: 'sd-product-details',
  templateUrl: 'product-details.component.html',
  styleUrls: ['product-details.component.scss'],
  providers: [StickyService, ScrollToService, HintsService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDetailsComponent extends BaseRoutingPageComponent implements OnInit, OnDestroy {

  itemDetail: any;
  priceSheets: any;
  productGroupsData: any;
  productImageUrl: string;
  uiModel: any = {};
  model: any = {};
  segmentsNavigationData: SegmentsParams = {
    segments: segments,
    sideNavSize: 100,
    marginLeft: 35,
  };
  segmentsAsyncs: any = segmentsAsyncs;
  isScrollingTo: boolean = false;
  rightPanelNavs: any[] = rightPanelNavs;

  sideNavStatus: string = '';
  sideNavTopButton: SideNavButtonModel = new SideNavButtonModel();
  sideNavBottomButton: SideNavButtonModel = new SideNavButtonModel();

  headerColor: string = '';
  paddingBottom: number = 0;
  dropdownPreviewOptions: any = productPreviewOptions;
  panelType: string;
  showMarketing: boolean = false;
  prevRouteShort: string = '';

  @HostBinding('class.details-page') detailsPageClass: boolean = true;

  @ViewChild(SegmentsNavigationComponent, {static: false}) segmentsNavigation: SegmentsNavigationComponent | void;

  @ViewChild(ProductPanelComponent, {static: true}) productPanel: ProductPanelComponent | void;

  @ViewChild('segmentsContent', {static: true}) segmentsContent: ElementRef | void;

  @ViewChildren('segmentItem') segmentItems: QueryList<ElementRef>;

  @ViewChild(DynamicNavsComponent, {static: true}) dynamicNavs: DynamicNavsComponent | void;

  @ViewChild(FitmentsComponent, {static: false}) fitmentsSegment: FitmentsComponent | void;

  @ViewChild(LoaderComponent, {static: false})
  loader: LoaderComponent | void;

  private itemDetailSub: Subscription;
  private notificationsSub: Subscription;
  private scrollSub: Subscription;
  private timezone: any;

  constructor(
    private scrollToService: ScrollToService,
    public productDetailsService: ProductDetailsService,
    public productPanelService: ProductPanelService,
    protected router: Router,
    private route: ActivatedRoute,
    private stickyService: StickyService,
    private location: Location,
    private brandService: BrandService,
    private itemDetailService: ItemDetailService,
    private segmentValidationService: SegmentValidationService,
    private ngZone: NgZone,
    private ref: ChangeDetectorRef,
    private toastrService: ToastrService,
    private sessionService: SessionService,
    private priceSheetService: PriceSheetService,
    private productGroupsService: ProductGroupsService,
    private marketingService: MarketingCopyDetailsService,
    private permissionsService: PermissionsService,
    private commentsService: CommentsService,
    private preferencesService: PreferencesService,
    private convertUTCToTZPipe: ConvertUTCToTZPipe,
    protected returnRouteService: ReturnRouteService,
  ) {
    super(router);

    ngZone.runOutsideAngular(() => {
      this.scrollSub = fromEvent(window, 'scroll')
      .pipe(takeWhile(() => this.isPageActive))
      .subscribe((e: any) => {
        this.stickyService.handleScrolling();
        if (this.uiModel.isHeaderMinimized && window.pageYOffset < 420) {
          this.uiModel.isHeaderMinSubject.next(false);
        }
        if (!this.uiModel.isHeaderMinimized && window.pageYOffset > 420) {
          this.uiModel.isHeaderMinSubject.next(true);
        }
      });
    });

    _.each(this.segmentsNavigationData.segments, (item: any, index: number) => {
      item.active = index === 0;
    });
  }

  /******************************************/
  /* Getter Functions                       */
  /******************************************/
  get updatedDate(): string {
    if (!this.itemDetail || !_.get(this, 'itemDetail.updated_at')) {
      return '';
    }
    const dateTZ = this.convertUTCToTZPipe.transform(this.itemDetail.updated_at, this.timezone);
    return moment(dateTZ).format('MMMM Do, YYYY');
  }

  get lastPublishedDate(): string {
    if (!this.itemDetail || !_.get(this, 'itemDetail.last_published_at')) {
      return '';
    }
    const dateTZ = this.convertUTCToTZPipe.transform(this.itemDetail.last_published_at, this.timezone);
    return moment(dateTZ).format('MMMM Do, YYYY');
  }

  get description(): string {
    return productHelpers.getHeaderDescription(this.itemDetail);
  }

  get itemId(): any {
    return _.get(this.route.snapshot.params, 'id', '');
  }

  get brandId(): string {
    return this.brandService.getBrand();
  }

  get partNumber(): string|undefined {
    return _.get(this.itemDetail, 'partNumber');
  }

  get itemStatus(): number {
    return _.get(this.itemDetail, 'status');
  }

  @HostListener('window:resize', ['$event']) onResize() {
    this.updatePageSpace();
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
  /*
   * Protect this page with permissions, `admin`, `catalog-view`, `catalog-edit`, 'repository'.
   */
    if (!this.permissionsService.hasPermission(['admin', 'catalog-view', 'catalog-edit', 'repository']) ) {
       this.router.navigate(['/logout']);
   }

    super.ngOnInit();

    this.uiModel = this.productDetailsService.uiModel;
    this.model = this.productDetailsService.model;
    this.rightPanelNavs[1].data = {itemId: this.itemId, brandId: this.brandId, statusLookup};
    this.scrollToService.init({
      pageScrollOffset: this.uiModel.headerMinHeight - this.uiModel.segmentItemOffsets
    });

    this._initStickyService();

    this.productPanelService.toggleProductPanel
      .pipe(takeWhile(() => this.isPageActive))
      .subscribe((obj: any) => {
        this.toggleProductPanel(obj.toggle, obj.segmentName, obj.data);
      });

    if (this.productPanel) {
      this.productPanel.onModalHidden
        .pipe(takeWhile(() => this.isPageActive))
        .subscribe(() => {
          if (this.segmentsNavigation) {
            this.segmentsNavigation.setActive(this.model.segment || 'item-details');
          }
          this.getItemDetail(this.brandId, this.itemId);
          this.model.isPanelOpened = false;
          this.updatePageSpace();
          this.updateLogs();
        });
    }


    this.uiModel.isHeaderMinSubject
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((val: boolean) => {
      if (this.uiModel.isHeaderMinimized === this.uiModel.isHeaderMinSubject.getValue()) { return; }
      this.uiModel.isHeaderMinimized = val;
      this.ref.markForCheck();
    });

    // navs change event
    this.subscribeNavsChange();

    // set active product-details preview option
    _.each(this.dropdownPreviewOptions, (item: any) => {
      item.active = item.route === '/product-details';
    });

    this.returnRouteSetup();
    _.defer(() => {
      const tab = _.get(this.route.snapshot.params, 'tab', 'hints');
      if (tab && this.dynamicNavs) { this.dynamicNavs.selectNav(tab); }
    });

    // get timezone
    this.preferencesService.getPreferences()
    .subscribe((preferences: any) => {
      this.timezone = preferences.timezone;
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.notificationsSub) {  this.notificationsSub.unsubscribe(); }
    if (this.scrollSub) {  this.scrollSub.unsubscribe(); }
    if (this.itemDetailSub) {  this.itemDetailSub.unsubscribe(); }
    this.model = {};
    this.uiModel = {};
    this.segmentsNavigationData.segments = [];
    this.itemDetail = null;
    this.segmentValidationService.resetValidation();
    setUnreadCommentsCount(this.rightPanelNavs, 0);
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onRouteChange(event: NavigationEnd) {
    window.scrollTo(0, 0);
    const { segment, id } = this.route.snapshot.params;

    forkJoin([
      this.getItemDetail(this.brandId, id),
      this.priceSheetService.fetchAll(this.brandId),
    ])
    .pipe(
        first(),
        takeWhile(() => this.isPageActive)
    )
    .subscribe((result: any) => {
      this.model.productId = id;
      this.priceSheets = result[1];
      this.updateRightNavs();
      if (this.dynamicNavs && _.get(this.dynamicNavs.activeNav, 'name') === 'comments') {
        this.dynamicNavs.componentRef.instance.fetch(this.brandId, this.partNumber, 'item');
      }
      this.initSegments()
      .pipe(
          first(),
        takeWhile(() => this.isPageActive)
      )
      .subscribe(null, null, () => {
        _.defer(() => this.updatePageSpace());
        if (this.route.snapshot.url[3] && this.route.snapshot.url[3].path === 'panel') {
          // if route to panel, open panel
          if (this.segmentsNavigation instanceof SegmentsNavigationComponent) {
            this.segmentsNavigation.setActive(segment);
          }
          this.toggleProductPanel(true, segment);
          return;
        }

        if (segment !== 'item-details') {
          // delay here is to avoid scroll to the another segment
          // when page is not fully rendered
          _.delay(() => {
            this.scrollToSegment(segment);
            if (this.segmentsNavigation) {
              this.segmentsNavigation.setActive(segment);
            }
          }, 1000);
        }

      });
    });
  }

  onSelectSegment(segment: any) {
    const segmentName = segment.name;
    this.scrollToSegment(segmentName);
  }

  onSideNavButtonClicked(value: any) {
    if (value === 5) {
      if (this.loader instanceof LoaderComponent) {
        this.loader.show();
      }
      this.itemDetailService.postAcceptImported(this.brandId, this.itemDetail.itemId)
        .subscribe( (itemDetail) => {
          this.itemDetail = setItemDetailValidation(itemDetail);
          this.populateSideNavValues(this.itemStatus);
          this.updateLogs();
          if (this.loader instanceof LoaderComponent) {
            this.loader.hide();
          }
          this.ref.markForCheck();
        });
    } else {
      if (this.loader instanceof LoaderComponent) {
        this.loader.show();
      }
      this.itemDetailService.postUpdateStatus(this.brandId, this.itemDetail.itemId, value)
        .subscribe( (itemDetail) => {
          this.itemDetail = setItemDetailValidation(itemDetail);
          this.populateSideNavValues(this.itemStatus);
          if (value === 8) {
            this.toastrService.info('', '', publishedToast());
          }
          if (value === 10) {
            this.toastrService.info('', '', unpublishedToast());
            this.closePage();
          }
          if (this.loader instanceof LoaderComponent) {
            this.loader.hide();
          }
          this.ref.markForCheck();
          this.updateLogs();
        });
    }
  }

  onPreviewOptionSelect(item: any) {
    if (item.route === `/${this.route.snapshot.url[0].path}`) { return; }
    this.router.navigate([item.route, this.itemId]);
  }

  onDetailsPageClose() {
    this.closePage();
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  returnRouteSetup() {
      /*
       * Setup the return route
       */
      let returnRoute = null;

      if (this.itemDetail) {
        returnRoute = this.getDefaultReturnRoute(this.itemStatus);
        this.setMarketingVisibility(returnRoute ? returnRoute.route : '');
      } else {
        returnRoute = this.returnRouteService.peak();
      }
      const prevPage = this.getPrevPage(returnRoute ? returnRoute.route : '');
      // show empty fitments for 'import-review-pies' page
      if (prevPage === 'import-review-pies' && this.itemDetail) {
        this.itemDetail.fitments = [];
      }

      this.setPageSettings(returnRoute ? returnRoute.route : '');
  }

  getDefaultReturnRoute(itemDetailStatus: number) {
    const segment = (!this.permissionsService.hasPermission(['admin', 'catalog-edit'])) ?
      'published' : searchPageHelpers.searchSegment(itemDetailStatus);

    const defaultRoute = '/my-products';
    return new ReturnRouteModel(segment ? `${defaultRoute}/${segment}` : defaultRoute, {smlocal: 1});
  }

  getItemDetail(brand: string, id: number): Observable<any> {
    const subj = new Subject<any>();
    // get timezone
    this.itemDetailSub = this.preferencesService.getPreferences()
    .pipe(flatMap((preferences: any) => {
      this.timezone = preferences.timezone;
      return this.itemDetailService.fetchItemDetail(brand, id);
    }),
    flatMap((itemDetail: any) => {
      this.itemDetail = setItemDetailValidation(itemDetail);
      console.log(this.itemDetail);

      this.updateSegmentsValidation();

      let validation = this.segmentValidationService.formatValidationTypes(itemDetail.validation);

      // PIES 6.7 validation row was added for test
      const pies65 = _.find(validation, {key: 'pies65'});
      if (pies65) {
        validation = [...validation, {
          key: 'pies67',
          title: 'PIES 6.7',
          valid: pies65.valid,
        }];
      }

      this.segmentValidationService.setData(validation);

      this.productImageUrl = productHelpers.getProductImageUrl(this.itemDetail);

      // set asets photo
      _.forEach(this.itemDetail.digitalAssets, (asset: any) => {
        asset.photo = getAssetThumbnail(asset, 'small');
      });

      return this.productGroupsService.fetch(this.brandId);
    }),
    flatMap((productGroups: any) => {
      this.productGroupsData = productGroups;
      return this.marketingService.fetchMarketingCopy(this.brandId, id);
    }))
    .subscribe((marketingData: any) => {
      this.itemDetail.marketing = this.groupMarketingData(marketingData);

      /*
       * Setup the return route
       */
      this.returnRouteSetup();

      this.populateSideNavValues(this.itemStatus);

      this.setUnreadCommentsCount();

      this.ref.markForCheck();
      subj.next(this.itemDetail);
      subj.complete();
    });
    return subj.asObservable();
  }

  updatePageSpace() {
    const pageViewportHeight = window.innerHeight - headerHeight - navPanelHeight;
    const lastEl = this.segmentItems.last;
    if (!lastEl) { return; }
    const lastSegmentHeight = lastEl.nativeElement.getBoundingClientRect().height;

    if (lastSegmentHeight < pageViewportHeight) {
      // if last segment height is less than viewport height -
      // add padding for ability to scroll to this segment
      this.paddingBottom = pageViewportHeight - lastSegmentHeight + 10;
    }
  }

  populateSideNavValues(status: number) {
    const values = productHelpers.populateSideNavValues(status, this.prevRouteShort === 'published');
    _.assign(this, values);

    if ( !this.permissionsService.hasPermission(['admin', 'catalog-edit'])) {
        this.sideNavTopButton.show = false;
        this.sideNavBottomButton.show = false;
    }
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private subscribeLogsRollback(logsComponent: any) {
    logsComponent.componentRef.instance.rollbackEnded
    .pipe(takeWhile(() => logsComponent.componentRef.instance.isActive))
    .subscribe((event: any) => {
      this.getItemDetail(this.brandId, this.itemId);
     if (this.fitmentsSegment) { this.fitmentsSegment.fetchFitments(); }
    });
  }

  private subscribeLogsSegmentClick(logsComponent: any) {
    logsComponent.componentRef.instance.segmentClicked
    .pipe(takeWhile(() => logsComponent.componentRef.instance.isActive))
    .subscribe((segmentId: string) => {
      const segment: any = _.find(segments, {id: segmentId});
      if (segment && segment.name) {
        this.scrollToSegment(segment.name);
      }
    });
  }

  private getPrevPage(prevRoute: string): any {
    if (!this.permissionsService.hasPermission(['admin', 'catalog-edit'])) {
      return 'published';
    }

    const splittedRoute = prevRoute.split('/');
    let page = splittedRoute.length > 1 ? splittedRoute[2] : null;
    if (prevRoute.indexOf('my-products') === -1 || !page) {
      page = _.get(JSON.parse(localStorage.getItem('myProductsSearchModel')), 'route', '');
    }
    return page;
  }

  private setPageSettings(prevRoute: string) {
    const prevRouteShort = this.getPrevPage(prevRoute);
    this.prevRouteShort = prevRouteShort;

    // set header color - deps from previous page
    const indexPageData = indexPagesData[prevRouteShort];
    this.headerColor = indexPageData ? indexPagesData[prevRouteShort].headerColor : 'darkred';
  }

  private setMarketingVisibility(prevRoute: string) {
    // show for Product & Publish pages
    const pagesWithoutMarketing = [
      'import-review-pies',
      'import-review-aces',
      'view-export',
    ];
    const prevRouteShort = this.getPrevPage(prevRoute);
    this.showMarketing = !(_.indexOf(pagesWithoutMarketing, prevRouteShort) >= 0);

    // change segments tabs
    if (!this.showMarketing) {
      this.segmentsNavigationData.segments = _.filter(segments, (segment: any) => {
        return segment.segment !== 'marketing';
      });
    }

    // remove Marketing segment if it should be hidden
    if (!this.showMarketing) {
      this.segmentsAsyncs  = _.omit(segmentsAsyncs, 'marketing');
    }
  }

  private get _rootUrl(): string {
    const url = this.route.snapshot.url;
    return url[0].path + '/' + url[1].path;
  }

  private _initStickyService() {
    this.stickyService.init(this.uiModel.headerMinHeight + this.uiModel.segmentItemOffsets , 'sticky', this.segmentsContent);
    this.stickyService.stickEvent
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((item: StickyComponent) => {
      if (this.isScrollingTo) {
        this.isScrollingTo = false;
        return;
      }
      if (this.segmentsNavigation instanceof SegmentsNavigationComponent) {
        this.segmentsNavigation.setActive(item.name);
      }
      this.ref.markForCheck();
      this.setLocationUrl(item.name);
      this.setSegmentName(item.name);
    });
  }

  private initSegments() {
    const asyncs: any = _.values(this.segmentsAsyncs);
    return forkJoin(asyncs);
  }

  private setLocationUrl(segmentName: string): void {
    this.location.go(`${this._rootUrl}/${segmentName}`);
  }

  private scrollToSegment(segmentName: string): void {
    this.isScrollingTo = true;
    this.scrollToService.scrollTo({scrollTarget: `#${segmentName}`});
    this.setLocationUrl(segmentName);
    this.setSegmentName(segmentName);
  }

  private setSegmentName(segmentName: string): void {
    this.model.segment = segmentName;
  }

  private toggleProductPanel(toggle: boolean, segment?: string, data?: any) {
    this.panelType = _.has(data, 'panelType') ? data.panelType : '';
    this.model.isPanelOpened = toggle;
    _.defer(() => {
      if (this.productPanel instanceof ProductPanelComponent) {
        this.productPanel.toggle(toggle, segment, data);
      }
    });
  }

  private updateLogs(): void {
    if (this.dynamicNavs && _.get(this.dynamicNavs.activeNav, 'name') === 'logs') {
      this.dynamicNavs.componentRef.instance.updateLogs();
    }
  }

  private groupMarketingData(data: any) {
    const subSegments = _.keys(data);
    const props = ['code', 'type'];
    const typeOrder: Array<any> = ['GCC', 'FAB'];
    const codeOrder: any = {
      brand: ['BRD', 'BOW', 'BPR', 'SBR'],
      product_groups: ['PGC', 'PSG'],
      part_type: ['PTI', 'PCC'],
    };
    const res: any = {};
    // group by
    _.forEach(subSegments, (subSegment: string) => {
      res[subSegment] = this.groupMarketingItemsByProps(data[subSegment], props, typeOrder, codeOrder[subSegment]);
    });
    return res;
  }

  private groupMarketingItemsByProps(data: Array<any>, props: Array<string>, typeOrder?: Array<string>, codeOrder?: Array<string>) {
    const res: Array<any> = [];
    let orderedData: any[];

    // group data by props
    _.forEach(data, (item: any) => {
      const common = _.pick(item, props);
      // find element with the same fields
      const matchEl = _.find(res, common);
      if (matchEl) {
        // if this element exists - extend copies
        this.extendMarketingItem(matchEl, item);
      } else {
        // if not - create new
        const newItem = this.createMarketingItem(item);
        res.push(newItem);
      }
    });
    // if needs to be ordered
    if (typeOrder && codeOrder) {
      orderedData = [];
      // order data by type & code
        _.forEach(codeOrder, (code: any) => {
          _.forEach(typeOrder, (type: any) => {
          orderedData = [...orderedData, ..._.filter(res, {type, code})];
        });
      });
    }
    return orderedData ? orderedData : res;
  }

  private extendMarketingItem(item: any, addItem: any) {
    if (!item.description[addItem.language]) {
      item.description[addItem.language] = [];
    }
    item.description[addItem.language].push(addItem.description);
  }

  private createMarketingItem(item: any): any {
    // {
    //    code: ...
    //    description: {
    //      EN: [...],
    //      ES: [...],
    //    }
    //    assignment_code: ...
    //    assignment_title: ...
    //    title: ...
    //    type: ...
    // }
    const newItem = {...item};
    newItem.description = {};
    newItem.description[item.language] = [item.description];
    delete newItem.language;
    return newItem;
  }

  private updateSegmentsValidation() {
    if (this.segmentsNavigation instanceof SegmentsNavigationComponent) {
      this.segmentsNavigation.toggleCircles((segment: any) => {
        return this.itemDetail.validation.segmentErrors.indexOf(segment.segment) > -1;
      });
    }
  }

  private subscribeNavsChange() {
    if (this.dynamicNavs instanceof DynamicNavsComponent) {
      this.dynamicNavs.changeNav
        .pipe(takeWhile(() => this.isPageActive))
        .subscribe((obj: any) => {
          if (obj.nav.name === 'logs') {
            _.defer(() => {
              obj.componentRef.instance.fetchLogs(this.brandId, this.itemId);
            });
            this.subscribeLogsRollback(obj);
            this.subscribeLogsSegmentClick(obj);
          } else if (obj.nav.name === 'comments') {
            if (this.partNumber) {
              obj.componentRef.instance.fetch(this.brandId, this.partNumber, 'item');
            }
            merge(
              obj.componentRef.instance.commentMarkedAsRead,
              obj.componentRef.instance.commentResolved
            )
              .pipe(takeWhile(() => obj.componentRef.instance.isActive))
              .subscribe(() => {
                this.setUnreadCommentsCount();
              });
          }
        });
    }
  }

  private updateRightNavs(): void {
    // Comments are allowed for working and published items only
    // Logs are allowed for working items only
    this.rightPanelNavs = _.filter(rightPanelNavs, (item: any) => {
      if (!item.availableFor) { return true; } // available for all items
      return _.includes(item.availableFor, this.itemStatus);
    });
  }

  private setUnreadCommentsCount() {
    this.commentsService.getUnreadCount(this.brandId, 'item', this.partNumber)
    .subscribe((data: any) => {
      setUnreadCommentsCount(this.rightPanelNavs, data.count);
      this.ref.markForCheck();
    });
  }

  private closePage() {
    let returnRoute = this.returnRouteService.pop();
    if (returnRoute &&
        returnRoute.route &&
        returnRoute.route.indexOf('/my-products') >= 0 &&
        indexPagesData[this.prevRouteShort]) {
      returnRoute = new ReturnRouteModel(`/my-products/${this.prevRouteShort}`, {smlocal: 1});
      this.router.navigate([`/my-products/${this.prevRouteShort}`]);
    } else {
      returnRoute = new ReturnRouteModel('/my-products/working', {smlocal: 1});
    }
    this.router.navigate([returnRoute.route], { queryParams: returnRoute.queryParams } );
  }
}
